module.exports = __webpack_public_path__ + "img/btn-count-up-off.1c602fe3.png";